import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.5'
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  descriptionInput: {
    width: '100%',
    '& .MuiFormHelperText-contained': {
      margin: '0 !important'
    }
  },
  titleInput: {
    width: '60%'
  },
  requirementInput: {
    display: 'flex',
    alignItems: 'center'
  }
}));
